<template>
  <div>
       <b-modal id="modal-1" title="Buscar por título">
            <b-row class="my-1">    
      <b-form-input id="input-default" style="margin:10px 20px;" placeholder="Título III" v-model="txtBuscaTitulo"></b-form-input>
      <div style="display: flex;justify-content: flex-end;margin-right: 20px;width: 100%;">
          <b-button variant="secondary" style="margin-right:10px;" @click="$bvModal.hide('modal-1')">Cancelar</b-button>
           <b-button variant="primary" style="height: 38px;"  @click="buscar">
               <span v-if="spinerBtn">
                   <b-spinner label="Spinning" style="width: 28px;height:28px"></b-spinner>
               </span>
               <span v-else style="">
                   Buscar
               </span>
               </b-button>
      </div>
    
  </b-row>
        </b-modal>
      <header class="h">          
          <div  class="nav-logo" style="margin-top: 10px;width: 100%;"> 
               <img src="https://www.lefisc.com.br/imagens/lefisc.svg" alt="" @click="Redirecionar" style="width: 120px;cursor:pointer;"> <span>{{nomeT}}</span>
          </div>           
      </header>
      <main>
          
          <div class="sidebar" :style="{'position': tirarSidebar ? 'absolute' : 'relative', 'left': tirarSidebar ? '-350px' : '0'}">
              <div>
                  <div style="display: flex;flex-direction: column;align-items: flex-start;">
                    <div class="links" v-for="(n,i) in menuApoio" :key="i" @click="AbrirLink(n.link)">
                        <img src="/regulamento/menu.svg" alt="" style="width: 12px;">{{n.item}}
                    </div>
                </div>
              </div>              
              <div v-if="desfazer" @click="desfazerBusca" style="width: 130px;background: red;margin-left: 10px;border-radius: 5px;color: #fff;font-size: 14px;padding: 6px;margin-top: 10px;cursor:pointer;">
                  Desfazer Busca
              </div>
            <LiquorTree v-model="value" :data="treeData" :options="treeOptions" ref="tree"  v-if="aa"/>
          </div>    
          <div class="conteudo"> 
                <div class="funcionalidades" v-if="(this.$route.params.idConteudo != 2770)">
                <span style="display:flex">
                    <img src="/regulamento/menuPreto.svg" alt="" style="cursor:pointer;" @click="tirarSidebar = !tirarSidebar">
                    <p v-if="txtBuscaTitulo">Termo pesquisado:<strong style="    margin-left: 3px;">{{txtBuscaTitulo}} </strong></p>
                </span>
                       
                    <span style="display:flex">
                        <img src="/regulamento/lista.png" alt="" style="width:25px;height:25px;cursor:pointer;" @click="tirarEspacamento = !tirarEspacamento">
                        <img src="/regulamento/diminuir.png" alt="" style="width:25px;height:25px;cursor:pointer;" @click="diminuir()">
                        <img src="/regulamento/aumentar.png" alt="" style="width:25px;height:25px;cursor:pointer;" @click="aumentar()">
                        <div @click="$bvModal.show('modal-1')" style="margin-right: 15px;">
                            <img src="/regulamento/busca.svg" alt=""> <span>Buscar</span>
                        </div>
                        <div @click="imprimir">
                            <img src="/regulamento/imprimir.svg" alt=""> <span>Imprimir</span>
                        </div> 
                    </span>                   
                </div>            
                <div v-if="spiner"  style="display:flex;    justify-content: center;"> 
                    <div v-html="conteudo" id="conteudoDiv" :class="{tirarEspacamento:tirarEspacamento}" :style="{'font-size':tamanhoFonte+'px'}" ></div>
                </div>               
                <div v-else style="display:flex;align-items:center;justify-content:center;height:100%;">
                    <b-spinner class="m-5" label="Busy"></b-spinner>
                </div>
          </div>
      </main>
  </div>
</template>

<script>
import axios from 'axios'
import LiquorTree from "liquor-tree";
export default {  
  components: { LiquorTree },
    data(){
        return{
            tirarSidebar:false,
            tirarEspacamento:false,
            tamanhoFonte:14,
            desfazer:false,
            aa:true,
            spinerBtn:false,
            txtBuscaTitulo:'',
            nomeT:'',
            spiner:true,
            titulo:'',
            idConteudoAtual: 0,
            conteudo:[],
            menuApoio:[],
            atual:null,
            value:null,
            treeOptions: {
                propertyNames: { 'text': 'item','id':'ancora','description':'conteudo'},                
            },
            treeData: this.getTreeData(),
            arraySemChildren:[]
        }
    },
    methods:{  
        diminuir(){
            
            if(this.tamanhoFonte >10){
                this.tamanhoFonte = this.tamanhoFonte - 2
                localStorage.setItem('fonteDosGuri',this.tamanhoFonte)
            }
        },
        aumentar(){
            
            if(this.tamanhoFonte < 18){
                this.tamanhoFonte = this.tamanhoFonte + 2
                localStorage.setItem('fonteDosGuri',this.tamanhoFonte)
            }
        },
        async desfazerBusca(){
            this.txtBuscaTitulo = ''
            this.desfazer = false
            this.arraySemChildren = []
            this.aa = false
            this.treeData =await  this.getTreeData()           
            this.recursividade(this.treeData)   
            setTimeout(()=>{
                this.$refs.tree.$on('node:selected', this.onNodeSelect)
            },90) 
            this.aa = true
        },
        async buscar(){
            console.log('vindo')
            try{
                
                this.spinerBtn = true        
                    await axios.get(`https://www.lefisc.com.br/api/produto/buscar/menu/${this.$route.params.idProduto}?termo=${this.txtBuscaTitulo}`,{headers:{"Desenvolvimento":'LEFISC'}})
                    .then(e=>{    
                        this.aa = false                    
                        console.log(e)
                        setTimeout(()=>{                            
                             if(e.data.length != 0){                            
                            this.desfazer = true                            
                            this.arraySemChildren=   []
                            this.treeData = e.data   
                            this.aa = true
                            setTimeout(()=>{
                                this.$refs.tree.$on('node:selected', this.onNodeSelect)
                                this.recursividade(this.treeData)   
                                this.aa = true
                            },90)  
                            this.$bvModal.hide('modal-1')   
                        }                      
                        },100)
                            
                        this.spinerBtn = false 
                    })                    
            }catch(e){
                this.spinerBtn = false               
            }
             
            this.spinerBtn = false 
            
        },
        Redirecionar(){
            window.location = 'https://www.lefisc.com.br/cliente/home'
        }  ,
        imprimir(){
            var conteudo = document.getElementById('conteudoDiv').innerHTML,
            tela_impressao = window.open('about:blank');
            tela_impressao.document.write(conteudo);
            tela_impressao.window.print();
            tela_impressao.window.close();
        }    ,
        AbrirLink(link){
            let regex = new RegExp(`/regulamento/${this.$route.params.idProduto}`)            
            if(regex.test(link)){
               
                 window.location = link
                return
            }else{
                 window.location = link
            }            
        },
        verificarItemParaAdicionar(b,titulo,sub){  
            this.arraySemChildren.push({item:b.item,ancora:b.ancora,idConteudo:b.conteudo,tituloPrincipal:titulo,tituloSub:sub})
        },
        recursividadeChildren(a,titulo,sub){
            for(let b of a){
                this.verificarItemParaAdicionar(b,titulo,sub)
                if(b.children != undefined){
                    this.recursividadeChildren(b.children,titulo,b.item)
                }
            }
        },
        recursividadeNo(node){
            if(node.parent != null){
                this.recursividadeNo(node.parent)
            }else{
                this.titulo = node.data.text
                return 
            }
        },
        recursividade(array){      
            for(let a of array){
                if(a.children != undefined){
                    this.verificarItemParaAdicionar(a,a.item,"")
                    this.recursividadeChildren(a.children,a.item)
                }else{
                    this.verificarItemParaAdicionar(a,a.item,"")
                }
            }
        },
        async getConteudoP(id){
            this.$router.push({name:'principal',params:{idConteudo:id,idProduto:this.$route.params.idProduto}})
                    await axios.get('https://www.lefisc.com.br/api/produto/conteudo/'.concat(this.$route.params.idConteudo ),{headers:{"Desenvolvimento":'LEFISC'}}).then(res => {
                        this.conteudo = res.data.conteudo
                    })
        },
        async getConteudo(id){
            if(id != this.idConteudoAtual && id != 0){ 
                this.spiner = false
                this.idConteudoAtual = parseInt(id)
                let regex = new RegExp('http')
                
                if(!regex.test(this.atual.ancora)){
                    await this.getConteudoP(id) 
                    setTimeout(()=>{
                        window.location.hash = this.atual.ancora   
                    },80)
                    this.spiner = true
                }else{
                    this.AbrirLink(this.atual.ancora)
                }
                this.spiner = true
                
            }else{
                let regex = new RegExp('http')
                
                if(regex.test(this.atual.ancora)){
                    this.AbrirLink(this.atual.ancora)
                }else{
                    window.location.hash = this.atual.ancora
                }
            }
                document.querySelectorAll('#conteudoDiv > p a').forEach(e=>{
                    e.parentElement.parentElement.style.background = ''
                        if(e.name ==this.atual.ancora){
                            e.parentElement.parentElement.style.background = 'yellow'
                        }
                    })
            
        },
        getTreeData(){
            return axios.get('https://www.lefisc.com.br/api/produto/'.concat(this.$route.params.idProduto),{headers:{"Desenvolvimento":'LEFISC'}}).then(res => {                
                this.menuApoio = JSON.parse(res.data.menuApoio) 
                this.nomeT =res.data.nome
                return JSON.parse(res.data.menuLateral)
            })
            .catch(e=>{
                if(e.response.status ==401){
                  window.location = 'https://www.lefisc.com.br/'
                }
            })
        },
        onNodeSelect(node) {
           this.recursividadeNo(node);
           let filter = this.arraySemChildren.filter(e=> e.item == node.data.text && e.ancora == node.id && e.tituloPrincipal == this.titulo);
           
           if(filter.length != 0){
               if(filter.length>1){
                   let filter2 = filter.filter(e=> e.tituloSub  == node.parent.data.text)
                   
                   this.atual  = filter2[0]   
                   
                   this.getConteudo(this.atual.idConteudo) 
               }else{
                   this.atual  = filter[0]   
                   
                    this.getConteudo(this.atual.idConteudo)
               }
                
           }
        }
    },
    async mounted(){      
        let fonte = localStorage.getItem('fonteDosGuri') 
        this.tamanhoFonte = fonte != null ? parseInt(fonte) : 14
        this.$refs.tree.$on('node:selected', this.onNodeSelect)
        this.treeData.then(e=>{
            this.recursividade(e)   
        })
        this.spiner = false
        let splitAncora = document.URL.split('#')
        await this.getConteudoP(this.$route.params.idConteudo)  
        this.spiner = true  
              
        if(splitAncora.length == 2){
            setTimeout(()=>{
                window.location.hash ='#'+splitAncora[1]   
            },80)
        }
    },
    

}
</script>

<style>
.tirarEspacamento *{
    padding:0px;
    margin:0px;
}
.modal-footer{
    display: none
}
.funcionalidades{
    display: flex;
 height: 40px;
    margin-right: 25px;
    justify-content: space-between;
    padding: 10px;
}
.funcionalidades img{
    width: 15px;
}
.funcionalidades div{
    border: 1px solid rgb(29, 59, 83);
box-sizing: border-box;
border-radius: 5px;
padding:0px 5px;
cursor: pointer;
display: flex;
    align-items: center;
height: 25px;
}
.funcionalidades img{
    margin-right: 10px;
}
html,div,body{
    scroll-behavior: smooth;
}
.links{
background: #595559;
    border-radius: 5px;
    color: #fff;
    padding: 3px 10px;
    font-size: 14px;
    margin-top:5px;
    margin-left: 10px;
    cursor: pointer;
        display: flex;
    
    align-items: center;
}
.links img{
    margin-right: 10px;
}
header.h{
    position: fixed;
    color:#fff;
    height: 10vh;
    background: #595559;
    padding: 10px 10px;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    justify-content: space-evenly;
}
header.h span::before{
   content: "";
    position: absolute;
    border-left: 1px solid #fff;
    height: 21px;
    left: -5px;
    top: 3px;
}
header.h .nav-logo{
 display: flex;
    align-items: center;    
}
header.h span{
    position: relative;
    font-weight: 600;
    margin-left: 12px;
        font-size: 18px;
}
main{    
    display: flex;
    width: 100%;   
}
main .conteudo{
width: 100%;
text-align: justify;
font-size: 14px;
display: flex;
        flex-direction: column;
        margin-top:10vh
}
main .conteudo #conteudoDiv{
    padding: 10px 30px;
overflow-y: auto;
height: 83vh;
width: 100%;
}
main .conteudo #conteudoDiv::-webkit-scrollbar-thumb {
    background-color: #595559;
    border-radius: 10px;
} 
main .conteudo #conteudoDiv::-webkit-scrollbar-track {
  background: #f2f2f2;   
}
main .conteudo #conteudoDiv::-webkit-scrollbar {
    width: 12px;    
}
main .sidebar{
    margin-top:10vh;
    height: 90vh;
    width: 100%;
    overflow-y: scroll;
    max-width: 350px;
    background: #EAEAEA;
}
.tree-root li{
    font-size:13px;
}
.tree-arrow{
         height: 27px !important;
}
.tree-arrow.has-child{
    width: 20px !important;
}
.tree-arrow.has-child:after{
   border: 2px solid #494646;
   height: 7px;
    width: 7px;
}
.tree-root li {
    font-size: 12px !important;
    font-weight: bold;
}
.tree-node.selected>.tree-content>.tree-anchor{
    font-weight: 700;
}
.tree-anchor {
    text-align: left;
    line-height: normal !important; 
     padding: 0px 0px !important;
    }
.tree-node {
    white-space: normal !important;
}
.tree-arrow.has-child:after{
    height: 7px !important;
    width: 7px !important;    
}
.tree-content{
    padding:0px ;
}
.sidebar::-webkit-scrollbar-thumb {
    background-color: #595559;
    border-radius: 10px;
} 
.sidebar::-webkit-scrollbar-track {
  background: #f2f2f2;   
}
.sidebar::-webkit-scrollbar {
    width: 12px;    
}
</style>